import React from "react";
import whitelogo from "../../assets/images/noteneticLogo.png";
import "../../custom-css/custom-style.css";

const Navbar = ({ children }) => {
  return (
    <nav className="navbar-nav">
      <div className="logo-cus">
        <h3 className="logo-link notenetic-text text-white mb-0">notenetic</h3>
        <img src={whitelogo} className="logo-swipe" alt="logo" />
      </div>

      <div className="ul_height_sidebar">
        {children}
      </div>
    </nav>
  );
};

export default Navbar;
